const isRenault = process.env.REACT_APP_BRAND === 'renault'
const DEFAULT_LANGUAGE = 'tr';

const APP_NAME = 'Renault Appointment Book';

const COOKIE = {
    AUHTORIZATION: 'authentication',
    LANGUAGE: 'language',
    DEVICE: 'device-id',
};

const HEADER = {
    AUHTORIZATION: 'authorization',
    LANGUAGE: 'language',
    DEVICE: 'device-id',
    DEVICE_OS: 'device-os',
    BRAND: 'brand',
    CUSTOMER_TYPE: 'customer-type'
}

const ROUTES = {
    INDEX: '/',
    APPOINTMENT_STATUS: '/appointment-status',
    DEFAULT: '/',
};

const IMAGES = {
    DACIA_MAP_MARKER: 'images/dacia/ic_dacia_location_active.png',
    RENAULT_MAP_MARKER: 'images/renault/ic_location_active.png',
    DACIA_MARKER: 'images/dacia/dacia-marker.png',
    RENAULT_MARKER: 'images/renault/renault-marker.png'
};

// Order defines step 
const STEP_LIST = [
    'step0',
    'step1',
    'step2',
    'timeSlotSelect',
    'step3',
    'step4',
]

const GOOGLE_API_KEY = 'AIzaSyAVvQCOoirbZSurC2kg1XKjDKs-_iVdezQ'

const GA_ID = isRenault ? 'UA-3902052-8' : 'UA-38615838-1'
const STEPS = { 'step0': 0, 'step1': 1, 'step2': 2, 'timeSlotSelect': 3, 'step3': 4, 'step4': 5, 'step5': 6 }
//dacia_logo_blue.jpg
const LOGO = {
    WHITE: isRenault ? '/images/renault_logo_white.png' : '/images/DACIA_R.svg',
    BLACK: isRenault ? '/images/renault_logo_black.png' : '/images/DACIA_K.svg',
    MARKER: isRenault ? '/images/dealer-marker-old.png' : '/images/dacia_map_icon.png',
    QR: isRenault ? '/images/qr_download.png' : '/images/qr_dacia.png',
    FAVICON: isRenault ? '/favicon.ico' : '/dacia_favicon.ico'
}

const MODELS = isRenault ?
    [
        'Avantime','Boreal', 'Captur', 'Clio', 'Clio 2', 'Clio 3', 'Clio 4', 'Clio Grand Tour', 'Clio HB', 'Clio RS', 'Clio Sport Tourer', 'Duster','Eski Meagne Coupe', 'Espace', 'Express', 'Fluence', 'Fluence ZE', 'Grand Scenic', 'Kadjar', 'Kangoo', 'Kangoo Binek', 'Kangoo Express', 'Kangoo Express Classic', 'Kangoo Multix', 'kangoo Multix Classic', 'Koleos', 'Laguna', 'Laguna 2', 'Laguna 3', 'Laguna Coupe', 'Latitude', 'Master', 'Master Frigo', 'Master Kamyonet', 'Master Minibus', 'Master Otobus', 'Master Panelvan', 'Megane', 'Megane 2', 'Megane 3', 'Megane Cabriolet', 'Megane Coupe', 'Megane HB', 'Megane RS', 'Megane Scenic', 'Megane Sedan', 'Megane Sport Tourer', 'Megane Wagon', 'Modus', 'Renault 11', 'Renault 12', 'Renault 19', 'Renault 21', 'Renault 25', 'Renault 5', 'Renault 9', 'Safrane', 'Scenic', 'Symbol', 'Talisman', 'Trafic', 'Trafic Multix', 'Trafic Panelvan', 'Trafic Passenger', 'Twingo', 'Twizy', 'Velsatis', 'Yeni Grand Scenic', 'Yeni Kangoo Express', 'Yeni Kangoo Multix', 'Yeni Master Frigo', 'Yeni Master Kamyonet', 'Yeni Master Minibus', 'Yeni Master Otobus', 'Yeni Master Panelvan', 'Yeni Megane HB', 'Yeni Trafic Multix', 'Yeni Trafic Panelvan', 'Yeni Trafic Passenger', 'Yeni Clio', 'Yeni Koleos', 'Yeni Megane', 'Yeni Megane Sedan', 'Zoe', 'Taliant'
    ]
    :
    [
        'Dokker Combi', 'Sandero', 'Duster', 'Lodgy', 'Logan MCV', 'Dokker Van', 'Spring'
    ]

const WEB_LINKS = {
    KVKK: isRenault ? 'https://www.renault.com.tr/kisisel-verilerin-korunmasi.html' : 'https://www.dacia.com.tr/kisisel-veriler.html',
    PORT: isRenault ? 'http://renaultport.com/download.html' : 'http://www.daciaport.com/',
}

const LIBRARY_LINK = isRenault ? 'renaultkutuphane.mais.com.tr' : 'daciakutuphane.mais.com.tr'

export {
    isRenault,
    GA_ID,
    DEFAULT_LANGUAGE,
    APP_NAME,
    ROUTES,
    COOKIE,
    HEADER,
    STEPS,
    STEP_LIST,
    GOOGLE_API_KEY,
    LOGO,
    MODELS,
    WEB_LINKS,
    LIBRARY_LINK,
    IMAGES
}
